import { AdminEventError } from '@/exceptions/admin-event/adminEvent.enum';
import { adminEventService } from '@/services/admin_event.service';
import { notificationService } from '@/services/notification.service';
import { useMutation, useQueryClient } from '@tanstack/react-query';

const useDeleteAdminEvent = () => {
    const queryClient = useQueryClient();
    return useMutation({
        mutationFn: async (eventId: number) =>
            await adminEventService.deleteAdminEvent(eventId),

        onSuccess: () => {
            queryClient.invalidateQueries({ queryKey: ['adminEvent'] });
            notificationService.success("event deleted Succesful");

        },

        onError: () => {
            throw new Error(AdminEventError.DELETE_ERROR);
        },
    });
};

export default useDeleteAdminEvent;